import {ModelContext} from '../../../types/app.types';
import {ModifierModel} from './Modifier.model';
import {ModifierGroup} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class ModifierGroupModel {
  public id: string;
  public name?: string;
  public modifiers: ModifierModel[];

  constructor(params: ModifierGroupModel) {
    this.id = params?.id;
    this.name = params?.name;
    this.modifiers = params?.modifiers;
  }

  public static fromCartV1(modifierGroup: ModifierGroup, modelContext: ModelContext): ModifierGroupModel {
    return new ModifierGroupModel({
      id: modifierGroup._id,
      name: modifierGroup.name?.translated ?? modifierGroup.name?.original ?? /* istanbul ignore next */ undefined,
      modifiers: (modifierGroup.modifiers ?? []).map((modifier) => ModifierModel.fromCartV1(modifier, modelContext)),
    });
  }

  /* istanbul ignore next */
  public static fromCartV2(modifierGroup: ModifierGroup, modelContext: ModelContext): ModifierGroupModel {
    return new ModifierGroupModel({
      id: modifierGroup._id,
      name: modifierGroup.name?.translated ?? modifierGroup.name?.original ?? /* istanbul ignore next */ undefined,
      modifiers: (modifierGroup.modifiers ?? []).map((modifier) => ModifierModel.fromCartV2(modifier, modelContext)),
    });
  }
}
